export type CommsAgendaItemType = 'message' | 'meetingReminderFirst' | 'meetingReminderSecond';

// View toggle on the agenda. "Upcoming" shows scheduled future sends + a
// short tail of in-flight cron sends; "Sent" shows historical sends with
// open/click engagement metrics.
export type ScheduleView = 'upcoming' | 'sent';

export function upcomingDateRange(): { startDate: string; endDate: string } {
  const now = new Date();
  const start = new Date(now.getTime() - 24 * 60 * 60 * 1000);
  const end = new Date(now.getTime() + 60 * 24 * 60 * 60 * 1000);
  return { startDate: start.toISOString(), endDate: end.toISOString() };
}

export function sentDateRange(): { startDate: string; endDate: string } {
  const now = new Date();
  const start = new Date(now.getTime() - 180 * 24 * 60 * 60 * 1000);
  return { startDate: start.toISOString(), endDate: now.toISOString() };
}

export function dateRangeForView(view: ScheduleView): { startDate: string; endDate: string } {
  return view === 'sent' ? sentDateRange() : upcomingDateRange();
}

export type CommsAgendaItemStatus = 'scheduled' | 'sending' | 'sent';

export type CommsAgendaItem = {
  id: string;
  type: CommsAgendaItemType;
  sendAt: string;
  subject: string;
  courseId: UUID;
  courseTitle: string;
  guideName?: string;
  guidePhotoUrl?: string;
  bodyExcerpt?: string;
  recipientCount: number;
  status: CommsAgendaItemStatus;
  editUrl: string;
  meetingId?: UUID;
  meetingScheduledAt?: string;
  // Engagement metrics. Both undefined when the item hasn't sent yet, OR
  // when the send pre-dates open/click tracking. Denominator is the
  // matching email_receipts count (not recipientCount), so the percentage
  // is "of those we have a receipt for, how many opened/clicked."
  receiptCount?: number;
  openedCount?: number;
  clickedCount?: number;
};
